import React, { useEffect } from "react";
import { XCircleIcon } from "@heroicons/react/20/solid";

const FormErrors = ({ submitError, touched }) => {
  useEffect(() => {
    if (!submitError || !touched) return;
    setTimeout(() => {
      let el = document.getElementById("sidebar_inner");
      if (el) {
        el.scrollTop = 0;
        return;
      }
      el = document.getElementById("error_container");
      if (el) {
        el.scrollIntoView({
          behavior: "smooth"
        });
      }
    }, 250);
  }, [submitError, touched]);

  if (!submitError || !touched) return null;

  const errors =
    typeof submitError === "string"
      ? [submitError]
      : Object.values(submitError);

  if (errors.length === 0) return null;

  return (
    <div id="error_container" className="bg-red-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800" tabIndex={0}>
            {errors.length === 1
              ? "There was an error with your submission."
              : `There were ${errors.length} errors with your submission.`}
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <ul className="list-disc pl-5 space-y-1">
              {errors.map((error, offset) => (
                <li key={`error${offset}`}>{error}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormErrors;
